export default __webpack_public_path__ + "static/blob6-f38805a1b67fb83508837e32acfaf687.svg";